$(document).ready(function(){
  let videoMobile = document.querySelector(".video--mobile");
  console.log(window.innerWidth);
  if (videoMobile) {
      setVideoSizeMobile('.eye-category-banner-video');
  }
  window.addEventListener('resize', function() {
      setVideoSizeMobile('.eye-category-banner-video');
  });
});

function setVideoSizeMobile(vid) {
  if (window.innerWidth < 767) {
    setWidth = document.querySelector(vid).clientWidth;
    Array.from(document.querySelectorAll(vid)).forEach(() => {      
      document.querySelector(vid).style.height = `${setWidth * 1.7}px`;
    });
  } else if (window.innerWidth > 767) {
    Array.from(document.querySelectorAll(vid)).forEach(() => {
      document.querySelector(vid).style.height = "100%";
    });
  }
}